/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Link } from '@bd/bdcore-named-routes';
import { SmoothLink } from '@bd/bdcore-utilities';
import { css, cx } from '@bd/bdui-styles/emotion';

const styles = css`
  width: 100%;
  background-color: #252525;
  padding: 15px 0;
  text-align: center;
  position:relative;
  z-index: 6;
  .menu-title {;
    width: auto;
    background-image: url(/images/icon-triangle-gold.svg);
    background-repeat: no-repeat;
    background-position: 92% center;
    display: inline-block;
    padding-right: 30px;
    color: #FFFFFF;
    font-weight: 800;
  }
  ul {
    padding: 0;
    text-align: left;
    width: 300px;
    display: none;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    top: 54px;
    list-style: none;

    &.open {
      display: block;
    }
    li {
      a {
        background-color: #FFFFFF;
        padding: 15px;
        border-bottom: 1px solid #CFCFCF;
        display: block;
        font-weight: 800;
        font-size: 16px;
        color: #3F3F3F;
      }
    }
  }
  @media (min-width: 992px) {
    padding: 0;
    text-align: left;
    .menu-title {
      display: none;
    }
    ul {
      text-align: left;
      list-style: none;
      padding: 0;
      margin: 0;
      display: block;
      position: relative;
      width: auto;
      left: auto;
      margin-left: 0;
      top: auto;
      li {
        display: inline-block;
        margin: 0 20px 0 0;
        a {
          background-color: transparent;
          line-height: 56px;
          font-weight: 800;
          font-size: 15px;
          color: #AC8B2F;
          text-align: center;
          text-transform: uppercase;
          padding: 0;
          border: 0;
          &.active {
            color: #FFFFFF;
          }
        }
      }
    }
  }
  @media (min-width: 1200px) {
    ul {
      li {
        margin: 0 30px 0 0;
      }
    }
  }
`;

class PageMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdown: false,
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.addWrapperRef = this.addWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);
  }

  toggleDropdown(e) {
    e.preventDefault();

    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  closeDropdown() {
    const { onSelect } = this.props;

    if (onSelect) {
      onSelect();
    }

    this.setState({
      dropdown: false,
    });
  }

  addWrapperRef(node) {
    if (!this.wrapperRefs) {
      this.wrapperRefs = [];
    }
    this.wrapperRefs.push(node);
  }

  handleClickOutside(event) {
    if (this.wrapperRefs && !this.wrapperRefs.find(ref => ref && ref.contains(event.target))) {
      this.closeDropdown();
    }
  }

  render() {
    const { className, title, items, match } = this.props;
    const { dropdown } = this.state;

    return (
      <div className={cx(styles, className)}>
        <div className="container">
          <a href="" className="menu-title" ref={this.addWrapperRef} onClick={this.toggleDropdown}>{title}</a>
          <ul className={`page-menu ${dropdown ? 'open' : ''}`} ref={this.addWrapperRef}>
            {
              items.map(item => {
                if (item.hide) {
                  return null;
                }

                if (item.name) {
                  return (
                    <li key={item.title} onClick={this.closeDropdown}>
                      <Link
                        name={item.name}
                        keepParams={item.keepParams}
                        params={item.params}
                      >
                        {item.title}
                      </Link>
                    </li>
                  );
                } else if (item.id) {
                  return (
                    <li key={item.id} onClick={this.closeDropdown}>
                      <SmoothLink
                        href={item.id}
                      >
                        {item.title}
                      </SmoothLink>
                    </li>
                  );
                }

                return (
                  <li key={item.path} onClick={this.closeDropdown}>
                    <a
                      href={item.path}
                      className={`${(match.path === item.path) ? 'active' : ''}`}
                    >
                      {item.title}
                    </a>
                  </li>
                );
              })
            }
          </ul>
        </div>
      </div>
    );
  }
}

PageMenu.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string,
      params: PropTypes.object,
      keepParams: PropTypes.bool,
    }),
  ),
  match: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
};

PageMenu.defaultProps = {
  className: undefined,
  items: [],
  onSelect: undefined,
};

export default withRouter(PageMenu);



// WEBPACK FOOTER //
// ./src/components/PageMenu.js